__turbopack_context__.v({
  "ctaWrapper": "styles-module__C7g0SW__ctaWrapper",
});
